
(function () {
  "use strict";

  function init(root) {
    if (!root || root.dataset.vipCReady === "1") return;
    root.dataset.vipCReady = "1";

    var GOOGLE_SCRIPT_URL =
      "https://script.google.com/macros/s/AKfycby7DmSS-t3TjGmcFXQFwDlv9TnnWBa-Q_MUj6-nBynZaDgIbnNSMMoQphrcCMXyZiwWgg/exec";

    var start = new Date("2026-10-31T08:00:00+01:00").getTime();
    var boxes = root.querySelectorAll("#cd b");

    function tick() {
      var d = Math.max(0, start - Date.now());
      [
        Math.floor(d / 86400000),
        Math.floor(d / 3600000) % 24,
        Math.floor(d / 60000) % 60,
        Math.floor(d / 1000) % 60
      ].forEach(function (v, i) {
        if (boxes[i]) boxes[i].textContent = String(v).padStart(2, "0");
      });
    }

    tick();
    window.setInterval(tick, 1000);

    var key = root.getAttribute("data-klaviyo-key");
    var listId = root.getAttribute("data-klaviyo-list");
    var redirect = root.getAttribute("data-confirmation-url");

    var query = location.search.slice(1);
    var utms = {};

    query.split("&").forEach(function (p) {
      if (!p) return;
      var parts = p.split("=");
      var k = decodeURIComponent(parts[0] || "");
      if (k.indexOf("utm_") === 0) {
        utms[k] = decodeURIComponent(
          (parts.slice(1).join("=") || "").replace(/\+/g, " ")
        );
      }
    });

    // Log registration to Google Sheets.
    // The endpoint creates a PENDING row. Klaviyo confirmation
    // tracking updates that row separately.
    function saveToGoogleSheets(email, submissionId) {
      var payload = new URLSearchParams({
        email: email,
        page_url: location.href.split("?")[0],
        submission_id: submissionId
      });

      return fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        body: payload,
        keepalive: true
      }).catch(function (err) {
        console.error("[VIP C] Google Sheets logging failed:", err);
      });
    }

    root.querySelectorAll(".vf").forEach(function (form) {
      var err = form.querySelector(".err");
      var btn = form.querySelector(
        'button[type="submit"],input[type="submit"]'
      );
      var em = form.querySelector('[name="email"]');
      var cb = form.querySelector('[name="consent"]');
      var page = form.querySelector('[name="page_url"]');
      var utm = form.querySelector('[name="utm"]');

      if (page) page.value = location.href.split("?")[0];
      if (utm) utm.value = query;

      function show(m, ok) {
        if (err) {
          err.textContent = m || "";
          err.style.display = m ? "block" : "none";
          err.style.color = ok ? "#dce4f0" : "";
        }
      }

      form.addEventListener("submit", async function (e) {
        e.preventDefault();

        if (!em || !em.value.trim() || !em.checkValidity()) {
          show("Bitte gib eine gültige E-Mail-Adresse ein.");
          if (em) em.focus();
          return;
        }

        if (!cb || !cb.checked) {
          show("Bitte bestätige deine Zustimmung zum E-Mail-Marketing.");
          if (cb) cb.focus();
          return;
        }

        if (!key || !listId || key === "XXXXXX") {
          show("Die Anmeldung ist noch nicht konfiguriert. Bitte versuche es später erneut.");
          return;
        }

        if (btn) {
          btn.disabled = true;
          btn.setAttribute("aria-busy", "true");
        }

        show("Deine Anmeldung wird verarbeitet …", true);

        var email = em.value.trim().toLowerCase();

        // One ID per form submission, shared by both systems.
        var submissionId =
          window.crypto && typeof window.crypto.randomUUID === "function"
            ? window.crypto.randomUUID()
            : "vip-c-" + Date.now() + "-" +
              Math.random().toString(36).slice(2, 12);

        var props = {
          vip_variant: "C",
          vip_page_url: location.href.split("?")[0],
          vip_utm: query,
          vip_consent: "yes",
          vip_consent_at: new Date().toISOString(),
          vip_form: form.dataset.form || "unknown",
          vip_submission_id: submissionId
        };

        Object.keys(utms).forEach(function (k) {
          props["vip_" + k] = utms[k];
        });

        var base = "https://a.klaviyo.com/client/";
        var headers = {
          accept: "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
          revision: "2026-10-15"
        };

        try {
          // First, create/update the Klaviyo profile.
          var p = await fetch(
            base + "profiles/?company_id=" + encodeURIComponent(key),
            {
              method: "POST",
              headers: headers,
              body: JSON.stringify({
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    properties: props
                  }
                }
              })
            }
          );

          if (!p.ok && p.status !== 409) {
            throw new Error("Klaviyo profile request: " + p.status);
          }

          // Submit the opt-in request to the configured Klaviyo list.
          var sub = await fetch(
            base + "subscriptions/?company_id=" + encodeURIComponent(key),
            {
              method: "POST",
              headers: headers,
              body: JSON.stringify({
                data: {
                  type: "subscription",
                  attributes: {
                    custom_source: "VIP Secret Sale – Variant C",
                    profile: {
                      data: {
                        type: "profile",
                        attributes: {
                          email: email,
                          subscriptions: {
                            email: {
                              marketing: {
                                consent: "SUBSCRIBED"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  relationships: {
                    list: {
                      data: {
                        type: "list",
                        id: listId
                      }
                    }
                  }
                }
              })
            }
          );

          if (!sub.ok && sub.status !== 202) {
            var errorText = await sub.text();
            console.error("[VIP C] Klaviyo subscription error:", sub.status, errorText);
            throw new Error("Klaviyo subscription request: " + sub.status);
          }

          // Log after Klaviyo accepts the subscription request.
          // no-cors means the browser cannot read the Google response.
          await saveToGoogleSheets(email, submissionId);

          if (window.fbq) {
            window.fbq("track", "Lead", {
              content_name: "VIP Secret Sale",
              variant: "C"
            });
          }

          if (redirect) {
            window.location.assign(redirect);
            return;
          }

          form.style.display = "none";
          var success = form.nextElementSibling;
          if (success) success.style.display = "block";

        } catch (ex) {
          console.error("[VIP Variant C] Submission failed:", ex);
          show("Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.");

          if (btn) btn.disabled = false;

        } finally {
          if (btn && !redirect) {
            btn.removeAttribute("aria-busy");
          }
        }
      });
    });

    var fab = root.querySelector("#fab");

    if (fab) {
      var seen = new Set();

      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.isIntersecting
              ? seen.add(entry.target)
              : seen.delete(entry.target);
          });

          fab.classList.toggle("on", seen.size === 0);
        }, { threshold: 0.1 });

        root.querySelectorAll(".vf").forEach(function (el) {
          io.observe(el);
        });

      } else {
        fab.classList.add("on");
      }

      fab.addEventListener("click", function () {
        setTimeout(function () {
          var input = root.querySelector("#em1");
          if (input) input.focus();
        }, 400);
      });
    }
  }

  document.querySelectorAll(".thomsen-vip-c").forEach(init);
})();
